import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DatalayerService } from '../services/DatalayerService';
import { useTitleWhenReady } from '../store/titleStore';

interface PageViewTrackerProps {
  children: ReactNode;
}

export function PageViewTracker(props: PageViewTrackerProps) {
  const location = useLocation();
  const title = useTitleWhenReady();

  useEffect(() => {
    if (title === null) return;
    DatalayerService.instance.pushPageView({}, { waitForCustomizationData: true });
  }, [location, title]);

  return <>{props.children}</>;
}
